import React, { useEffect, useState } from "react";
import { DEVICE_DETAILS } from "config";
import { useHistory } from "react-router-dom";
import { Autocomplete } from "@material-ui/lab";
import { BrowserRouter } from "react-router-dom";
import RouterConfig from "navigation/RouterConfig";
import Header from "components/Header";
import TestEnvironment from "components/TestEnvironment";
import  TranslationProvider from "providers/TranslationProvider";
import { RCProvider } from "providers/";
import Refresh from "components/Refresh";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  Card,
  CardContent,
  Button,
  IconButton,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  TextField,
  Select,
  Checkbox,
  MenuItem,
  InputLabel,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import CancelIcon from "@material-ui/icons/Cancel";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { GLOBAL_FORM_SUCCESS } from "navigation/CONSTANTS";
// import { saveIdeaWVForm } from "../../services/wvForms";
import { saveGlobalWVForm } from "../../services/wvForms";
import { SET_EMPTY } from "../../config";

import { set } from "date-fns";
import { updateLang } from "i18n";
import { getUserDetails } from "services";
import { isEmptyObject } from "utils";

const KEY = "androidSurvey";
const DISABLE_OBJECT = {

  email: false,

};


const useStyles = makeStyles((theme) => ({
  header: {
    border: `1px solid #dadce0`,
    wordWrap: "break-word",
    pageBreakInside: "avoid",
    background: "#fff",
    borderRadius: 8,
    borderTopWidth: 10,
    borderTopColor: theme.palette.primary.main,
    marginTop: 10,
  },
  root: {
    minWidth: "80%",
  },
  form: {
    "&>*": {
      marginBottom: 16,
    },
  },
  textField: {
    minWidth: "50%",
  },
  textArea: {
    width: "100%",
  },
}));

// const { t, i18n } = useTranslation();

const errorMessageObject = {
  empId: SET_EMPTY,
  empName: SET_EMPTY,
  empEmail: SET_EMPTY,
  idea: SET_EMPTY,
  benefits: SET_EMPTY
};

const MAIL_FORMAT_RE = /^[A-Za-z0-9_.-]+\w*@ironmountain\.+(\w*\.?\w{2,7})+$/;


const GlobalForm = () => {
  const history = useHistory();
  const theme = useTheme();
  const classes = useStyles();

  const [empId, setEmpId] = useState("");
  const [managerName,setManagerName] = useState("");
  const [managerEmail,setManagerEmail] = useState("");
  const [isBehalf, setIsBehalf] = useState(SET_EMPTY);
  const [currIdeaOwner, setCurrIdeaOwner] = useState("");
  const [ideaOwners, setIdeaOwners] = useState([]);
  const [businessLine, setBusinessLine] = useState([]);
  const [isOtherBusinessVisible, setOtherBusinessVisible] = useState(false);
  const [otherBusinessLine, setOtherBusinessLine] = useState("");
  const [empName, setEmpName] = useState("");
  const [maskedEmpName, setMaskedEmpName] = useState("");
  const [empEmail, setEmpEmail] = useState("");
  const [empEmailVisible, setEmpEmailVisible] = useState(true);
  const [empJobRole, setEmpJobRole] = useState("");
  const [empProductDescription, setEmpProductDescription] = useState("");
  const [empCountry, setEmpCountry] = useState("");
  const [empDetailsDisabled, setEmpDetailsDisabled] = useState(DISABLE_OBJECT);
  const [empRegion, setEmpRegion] = useState("");
  const [empExists, setEmpExists] = useState(false);
  const [impact, setImpact] = useState("");
  const [categoriesSelected, setCategoriesSelected] = useState([]);
  const [isOtherCategoryVisible, setIsOtherCategoryVisible] = useState(false);
  const [otherCategory, setOtherCategory] = useState("");
  const [description, setDescription] = useState("");
  const [isSolExistProb, setIsSolExistProb] = useState(SET_EMPTY);
  const [solExistProb, setSolExistProb] = useState("");
  const [isAppliedLocally, setIsAppliedLocally] = useState("");
  const [monthsRequired, setMonthsRequired] = useState("");
  const [idea, setIdea] = useState("");
  const [benefits, setBenefits] = useState("");
  const [geography, setGeography] = useState("");
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState(errorMessageObject);
  const [fetchedUser, setFetchedUser] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [isSubmitPressed, setIsSubmitPressed] = useState(false);
  const [categoriesOpen, setCategoriesOpen] = useState(false);
  const [businessOpen, setBusinessOpen] = useState(false);
  const [errorAlertDiag, setErrorAlertDiag] = useState(false);
  const { t, i18n } = useTranslation();
  const [empisActive,setEmpisActive]= useState(true);
  const empIdRef = React.useRef(); 



  

  const getEmpDetails = async (empId) => {
    await getUserDetails(empId)
      .then((details) => {
        const empDetails = details.data();
        if (empDetails) {
          let firstName = empDetails.firstName;
          let lastName = empDetails.lastName;
          let managerLastName = empDetails?.managerLastName;
          let managerFirstName = empDetails?.managerFirstName;
          setEmpName(`${firstName} ${lastName}`);
          setEmpEmail(empDetails.email ? empDetails.email : SET_EMPTY);
          setManagerEmail(empDetails.managerEmail ? empDetails.managerEmail : SET_EMPTY);
          setManagerName(`${managerFirstName} ${managerLastName}`)
          setEmpExists(true);
         
          const disableObject = {
          
            email: empDetails.email ? true : false,
          
          };
          if(empDetails.isActiveWorker===true){
            setEmpisActive(true)
          }
          else{
            setEmpisActive(false)
            setEmpName(SET_EMPTY);
            setEmpEmail(SET_EMPTY);
            setEmpEmailVisible(true);
            setManagerEmail(SET_EMPTY);
            setManagerName(SET_EMPTY);
            setEmpDetailsDisabled(DISABLE_OBJECT);
            empIdRef && empIdRef.current.focus();
          }
          if (isSubmitPressed) {
            const errObject = {
              empName: disableObject.name ? "" : "Required",
              empEmail: disableObject.email ? "" : "Required",
             
            };
            setErrorMessage((oldState) => ({
              ...oldState,
              ...errObject,
            }));
          }
          setEmpDetailsDisabled(disableObject);
          
        } else {
         
          setEmpEmail(SET_EMPTY);
          setEmpEmailVisible(true);
          setEmpName(SET_EMPTY);
          setEmpDetailsDisabled(DISABLE_OBJECT);
          setEmpExists(false);
          setManagerEmail(SET_EMPTY);
          setManagerName(SET_EMPTY);
          empIdRef && empIdRef.current.focus();
        }
      })
      .catch((error) => {
        setEmpName(SET_EMPTY);
        setEmpEmail(SET_EMPTY);
        setEmpEmailVisible(true);
      
        setEmpDetailsDisabled(DISABLE_OBJECT);
        setEmpExists(false);
        setManagerEmail(SET_EMPTY);
        setManagerName(SET_EMPTY);
        console.log("Error in get Employee Details" + error);
      });
    setFetchedUser(true);
  };
  
  const handleEmpIdChange = async (event) => {
    const value = event.target.value;
    if (value.length < 8) {
      const lastCharacter = value.charAt(value.length - 1);
      const isNumber = !isNaN(lastCharacter - parseFloat(lastCharacter));
      if (isNumber || isEmptyObject(value)) {
        handleOnBlur(event);
        if (value.length > 5) {
           await getEmpDetails(value);
            setEmpId(value);
        } else {
          setEmpId(value);
          setEmpName(SET_EMPTY);
          setEmpEmail(SET_EMPTY);
          setEmpEmailVisible(true);
          setManagerEmail(SET_EMPTY);
          setManagerName(SET_EMPTY);
          setEmpDetailsDisabled(DISABLE_OBJECT);
        
          if (isSubmitPressed) {
            const errObject = {
              empEmail: "",
             
            };
            setErrorMessage((oldState) => ({
              ...oldState,
              ...errObject,
            }));

          }
        }
      }
    }
  }

  const handleCommentsChangeTwo = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setIdea(value);
  };

  const handleCommentsChangeThree = (event) => {
    const valueThree = event.target.value;
    handleOnBlur(event);
    setBenefits(valueThree);
  };


  
  const handleProcessingOpen = () => {
    setProcessing(true);
  };

  const handleProcessingClose = () => {
    setProcessing(false);
  };



  const validateEmail = (email) => {
    if (MAIL_FORMAT_RE.test(email)) {
      if (email.length - "@ironmountain".length !== -1) {
        return true;
      }
    }
  };

  const handleOnBlur = (event) => {
    const target = event.target;
    if (target.id) {
      if (
        !target.value ||
        target.value === null ||
        target.value.trim() === SET_EMPTY
      ) {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.id]: "Required",
        }));
      } else {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.id]: SET_EMPTY,
        }));
      }
    } else if (target.name) {
      if (
        target.value === undefined ||
        target.value === null ||
        target.value === SET_EMPTY
      ) {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.name]: "Required",
        }));
      } else {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.name]: SET_EMPTY,
        }));
      }
    }
  };

  const checkErrors = () => {
    const errorMessages = {
      empId: SET_EMPTY,
      empEmail: SET_EMPTY,
      idea: SET_EMPTY,
      benefits:SET_EMPTY
    };
    const REQUIRED = "Required";

    if (empId.trim() === SET_EMPTY) {
      errorMessages.empId = REQUIRED;
    } else if (empId.trim().length < 6) {
      errorMessages.empId = t("other.lblMinimumSixDigitsRequired");
    } else {
      errorMessages.empId = SET_EMPTY;
    }

    if (idea.trim() === SET_EMPTY) {
        errorMessages.idea = REQUIRED;
      } else {
        errorMessages.idea = SET_EMPTY;
      }


    if (benefits.trim() === SET_EMPTY) {
      errorMessages.benefits = REQUIRED;
    } else {
      errorMessages.benefits = SET_EMPTY;
    }
    console.log("benefits",benefits);
    setErrorMessage(errorMessages);
  };

  

  const onClear = () => {
    setIsSubmitPressed(false);
    setEmpId(SET_EMPTY);
  
   
    setEmpEmail(SET_EMPTY);
    setEmpEmailVisible(true);
   
   
    setIdea(SET_EMPTY);
    setBenefits(SET_EMPTY);
    setEmpDetailsDisabled(DISABLE_OBJECT);
    setManagerEmail(SET_EMPTY);
    setManagerName(SET_EMPTY);
    
  };

  const onSubmit = async () => {
    checkErrors();
    setIsSubmitPressed(true);
    if (!isSubmitDisabled) {
      let form = {
        key: KEY,
        empId: empId.trim(),
        empName: empName.trim(),
        email: empEmail.trim(),
        idea: idea.trim(),
        benefits:benefits.trim(),
        deviceType: DEVICE_DETAILS.deviceType,
        managerName,
        managerEmail
      
      };
      handleProcessingOpen();
      try {
        let globalFormID = await saveGlobalWVForm(form);
        console.log(`
      globalAndroidSurvey-form
      globalAndroidSurveyFormID is ${globalFormID}
      `);
        handleProcessingClose();
        history.push(GLOBAL_FORM_SUCCESS);
      } catch (error) {
        console.log(`
        globalAndroidSurvey-form 
      error is ${error}
     `);
    }
  
    } else {
      setErrorAlertDiag(true);
    }
  };
  const {version}=useSelector((state)=>state.translation.i18n)
  if (version && version>1) {
    updateLang();
  }
  useEffect(() => {
    const header = document.querySelector("#header-bar");
    const testEnv = document.querySelector(".imtime-testEnvironment");
    if (header) header.style.display = "none";
    if (testEnv) testEnv.style.display = "none";
  }, []);

  useEffect(() => {
    if (
      empId.trim().length < 6 ||
      empEmail.trim() === SET_EMPTY ||
      !validateEmail(empEmail.trim()) ||
      idea.trim() === SET_EMPTY ||
      benefits.trim() === SET_EMPTY
     
    ) {
      setIsSubmitDisabled(true);
    } else {
      setIsSubmitDisabled(false);
    }
  }, [
    empId,
    empEmail,
    idea,
    benefits
    
  ]);

  return (
    <>
      <Container maxWidth="sm">
        <form className={classes.form} noValidate autoComplete="off">
        <Grid container direction="column" alignItems="stretch" spacing={2}>
            <Grid item>
                  <TranslationProvider />                         
                <Header  isLogoLinkDisabled={DEVICE_DETAILS.deviceType === "mobile" ? true : false}/>  
            </Grid>
         </Grid>   
          <Grid container direction="column" alignItems="stretch" spacing={2}>
            <Grid item>
              <Card className={classes.header}>
                <CardContent>
                  <Typography variant="h6" gutterBottom color="textPrimary">                    
                    {t("other.lblGlobalForm")}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                  {t("other.lblGlobalFormHeading")}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                  {t("other.lblGlobalFormHeadingTwo")}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblYourWorkerId")}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    value={empId}
                    inputRef={empIdRef}
                    onChange={(event) =>{
                      const value = event.target.value;
                        if (value.length < 8) {
                          const lastCharacter = value.charAt(value.length - 1);
                          const isNumber = !isNaN(lastCharacter - parseFloat(lastCharacter));
                          if (isNumber || isEmptyObject(value)) {
                            console.log("function", empisActive, empExists);
                            setEmpId(value);
                            setEmpExists(true);
                            setEmpisActive(true);
                            setEmpName(SET_EMPTY);
                            setEmpEmail(SET_EMPTY);
                            setEmpEmailVisible(true);
                            setManagerEmail(SET_EMPTY);
                            setManagerName(SET_EMPTY);
                            setEmpDetailsDisabled(DISABLE_OBJECT);
                          }
                        }
                    }}
                    onBlur={handleEmpIdChange}
                    id="empId"
                    label={t("other.lblEnterYourWorkerId")}
                    className={classes.textField}
                    error={!!errorMessage.empId}
                    helperText={
                      !!errorMessage.empId
                        ? errorMessage.empId
                        : empId.trim().length < 6
                        ? t("other.lblMinimumSixDigitsRequired")
                        : ""
                    }
                  />
                  {!empExists && empId.length > 5 ?(
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      color="textPrimary"
                      style={{color:"red"}}
                    >
                      {t("pgHome.errNotFoundWorker")}                   
                    </Typography>
                  ): !empisActive  && empId.length > 5 &&
                  (
                    <Typography
                    variant="subtitle2"
                    gutterBottom
                    color="textPrimary"
                    style={{color:"red"}}
                  >
                    {t("pgHome.errInactiveWorker")}
                  </Typography>	
                  )}
                  {empEmail !== "" &&  
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    color="textPrimary"
                    // style={{color:"red"}}
                  >
                    {empEmail}
                  </Typography>
                  
                  }
              	
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblAndroidIdeaQueTwo")}                    
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    value={idea}
                    onChange={handleCommentsChangeTwo}
                    id="idea"
                    label={t("other.lblAnswerTwo")} 
                    className={classes.textArea}
                    multiline
                    error={!!errorMessage.idea}
                    helperText={errorMessage.idea}
                  />
                </CardContent>
              </Card>
            </Grid>


            
            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblAndroidIdeaQueThree")}                    
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    value={benefits}
                    onChange={handleCommentsChangeThree}
                    id="benefits"
                    label={t("other.lblAnswerThree")} 
                    className={classes.textArea}
                    multiline
                    error={!!errorMessage.benefits}
                    helperText={errorMessage.benefits}
                  />
                </CardContent>
              </Card>
            </Grid>


            <Grid item>
              <Grid
                container
                direction="row"
                justify="space-between"
                spacing={2}
              >
                <Grid item>
                  <Button
                    type="Button"
                    variant="text"
                    color="secondary"
                    onClick={onClear}
                  >
                    {t("other.lblClearForm")}                    
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={onSubmit}
                    disabled={ !empExists && empId.length > 5 || !empisActive }
                  >
                    {t("pgHome.btEmpId")}                    
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Container>
      <Dialog
        open={processing}
        onClose={handleProcessingClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick={true}
      >
        <DialogTitle id="alert-dialog-title">{t("other.lblSubmitting")} </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {t("other.lblPleaseWaitToSubmt")}   <br /> <br />
            <Grid container justify="center">
              <Grid item>
                <CircularProgress />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={errorAlertDiag}
        onClose={() => {
          setErrorAlertDiag(false);
        }}
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
        disableBackdropClick={true}
      >
        <DialogTitle id="error-dialog-title"> {t("other.tlError")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="error-dialog-description">
          {t("other.lblPleaseFillAllFields")}  <br /> <br />
             <Grid container justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: 90 }}
                  onClick={() => {
                    setErrorAlertDiag(false);
                  }}
                >
                 {t("pgPunch.btnOK")} 
                </Button>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default GlobalForm;
